module.exports = __webpack_public_path__ + "static/media/Mixing Tube.a9b4c617.svg";